"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var __jsx = _react["default"].createElement;
var MinicartContent = function MinicartContent(props) {
  var progressBar = props.progressBar,
    productRows = props.productRows,
    orderSummary = props.orderSummary,
    itemsAmountInCart = props.itemsAmountInCart;
  var translations = {
    yourCart: (0, _langLibrary["default"])("Your cart"),
    noProducts: (0, _langLibrary["default"])("No products in cart"),
    noReservationInfo: (0, _langLibrary["default"])("Do not hesitate")
  };
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column",
      pb: "s10"
    }
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      font: "heading2",
      mb: "s10",
      textAlign: "center",
      color: "main"
    }
  }, " ", translations.yourCart, " (", itemsAmountInCart, ")"), itemsAmountInCart === 0 && __jsx(_Box["default"], {
    as: "span",
    sx: {
      textAlign: "center",
      font: "base_sans",
      color: "main"
    }
  }, translations.noProducts), itemsAmountInCart > 0 && __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      mb: "s8"
    }
  }, progressBar), __jsx(_Box["default"], {
    sx: {
      textAlign: "center",
      font: "s_caps",
      color: "main",
      mb: "s8"
    }
  }, translations.noReservationInfo), __jsx(_Box["default"], {
    sx: {
      mb: "s8"
    }
  }, productRows.map(function (product, index) {
    var _product$props;
    return __jsx(_Box["default"], {
      "data-test": "product-mini-cart",
      key: "".concat(index).concat(product === null || product === void 0 ? void 0 : (_product$props = product.props) === null || _product$props === void 0 ? void 0 : _product$props.product.sku),
      sx: {
        py: "s8",
        borderStyle: "solid",
        borderBottomWidth: "1px",
        borderColor: "neutral"
      }
    }, product);
  })), __jsx(_Box["default"], null, orderSummary)));
};
var _default = MinicartContent;
exports["default"] = _default;